<div class="container-fluid online-payments">
  <div class="row align-items-center mb-3">
    <div class="col">
      <h3 class="mb-0">
        <i class="fa fa-credit-card"></i> Online Payments
      </h3>
      <small class="text-muted">LawPay and Payload payment activity in one place</small>
    </div>
    <div class="col-auto">
      <a class="btn btn-sm btn-outline-secondary mr-2" routerLink="/lawpay_payments">
        LawPay Queue
      </a>
      <button class="btn btn-sm btn-outline-secondary" (click)="refresh()" [disabled]="loading" title="Refresh">
        <i class="fa fa-refresh" [class.fa-spin]="loading"></i>
      </button>
    </div>
  </div>

  <div class="filters mb-3">
    <div class="form-row align-items-end">
      <div class="form-group col-md-2">
        <label>Provider</label>
        <select class="form-control form-control-sm" [(ngModel)]="searchParams.provider" (change)="search(true)">
          <option value="">All</option>
          <option *ngFor="let provider of providers" [value]="provider">{{ providerLabel(provider) }}</option>
        </select>
      </div>
      <div class="form-group col-md-2">
        <label>Status</label>
        <select class="form-control form-control-sm" [(ngModel)]="searchParams.status" (change)="search(true)">
          <option value="">All</option>
          <option *ngFor="let status of statuses" [value]="status">{{ statusLabel(status) }}</option>
        </select>
      </div>
      <div class="form-group col-md-2">
        <label>From</label>
        <input class="form-control form-control-sm" type="date" [(ngModel)]="searchParams.from_date" (change)="search(true)">
      </div>
      <div class="form-group col-md-2">
        <label>To</label>
        <input class="form-control form-control-sm" type="date" [(ngModel)]="searchParams.to_date" (change)="search(true)">
      </div>
      <div class="form-group col-md-2">
        <label>Rows</label>
        <select class="form-control form-control-sm" [(ngModel)]="searchParams.per_page" (change)="search(true)">
          <option *ngFor="let option of perPageOptions" [ngValue]="option">{{ option }}</option>
        </select>
      </div>
      <div class="form-group col-md-2 text-right">
        <button class="btn btn-sm btn-outline-secondary" (click)="clearFilters()" [disabled]="loading">
          Clear
        </button>
      </div>
    </div>
  </div>

  <div class="row">
    <div [class.col-xl-8]="selectedPayment" [class.col-12]="!selectedPayment">
      <div class="payment-list">
        <div class="payment-list-header">
          <strong>Payments</strong>
          <span class="badge badge-secondary">{{ totalCount }}</span>
        </div>

        <div *ngIf="loading" class="text-center p-4">
          <i class="fa fa-spinner fa-spin fa-2x"></i>
          <p class="mb-0 mt-2">Loading payments...</p>
        </div>

        <div *ngIf="!loading && payments.length === 0" class="text-center p-4 text-muted">
          <i class="fa fa-inbox fa-3x mb-2"></i>
          <p class="mb-0">No online payments found</p>
        </div>

        <div *ngIf="!loading && payments.length > 0" class="table-responsive">
          <table class="table table-hover table-sm mb-0">
            <thead>
              <tr>
                <th>Date</th>
                <th>Provider</th>
                <th>Payer</th>
                <th>Invoice</th>
                <th class="text-right">Amount</th>
                <th>Method</th>
	                <th>Status</th>
	                <th>Reconciliation</th>
	                <th class="text-center">Actions</th>
	              </tr>
	            </thead>
            <tbody>
              <tr *ngFor="let payment of payments; trackBy: trackPayment"
                  (click)="setSelectedPayment(payment)"
                  [class.refund-reversal-row]="isRefundOrReversal(payment)"
                  [class.selected-row]="selectedPayment && selectedPayment.provider === payment.provider && selectedPayment.id === payment.id">
                <td>{{ formatDate(payment.transaction_at || payment.created_at) }}</td>
                <td>
                  <span class="badge" [ngClass]="providerBadgeClass(payment.provider)">
                    {{ providerLabel(payment.provider) }}
                  </span>
                </td>
                <td>
                  <strong>{{ payment.payer_name || 'Unknown' }}</strong>
                  <br *ngIf="payment.payer_email">
                  <small class="text-muted">{{ payment.payer_email }}</small>
                </td>
                <td>{{ payment.invoice_reference || payment.payload_invoice_id || '-' }}</td>
                <td class="text-right" [class.refund-reversal-amount]="isRefundOrReversal(payment)">
                  <strong>{{ payment.formatted_amount }}</strong>
                  <span *ngIf="isRefundOrReversal(payment)" class="d-block small">Refund/Reversal</span>
                </td>
                <td>{{ payment.payment_method_display || statusLabel(payment.payment_method_type) }}</td>
                <td>
                  <span class="badge" [ngClass]="providerStatusBadgeClass(payment.provider_status)">
                    {{ statusLabel(payment.provider_status) }}
                  </span>
                </td>
                <td>
	                  <span class="badge" [ngClass]="workflowBadgeClass(payment.workflow_status)">
	                    {{ statusLabel(payment.workflow_status) }}
	                  </span>
	                </td>
	                <td class="text-center" (click)="$event.stopPropagation()">
	                  <button class="btn btn-sm btn-outline-danger"
	                          (click)="openRefundModal(payment, $event)"
	                          *ngIf="canRefund(payment)"
	                          title="Refund">
	                    <i class="fa fa-undo"></i> Refund
	                  </button>
	                  <span class="text-muted small" *ngIf="!canRefund(payment) && (payment.is_refunded || payment.refund_pending || payment.refund_failed || payment.provider === 'payload')"
	                        [title]="refundUnavailableText(payment)">
	                    {{ payment.is_refunded ? 'Refunded' : (payment.refund_pending ? 'Pending' : '-') }}
	                  </span>
	                </td>
	              </tr>
            </tbody>
          </table>
        </div>

        <div class="payment-list-footer" *ngIf="totalPages > 1">
          <pagination
            [totalItems]="totalCount"
            [itemsPerPage]="perPage"
            [(ngModel)]="currentPage"
            (pageChanged)="pageChanged($event)"
            [boundaryLinks]="true"
            [maxSize]="5"
            previousText="&lsaquo;"
            nextText="&rsaquo;"
            firstText="&laquo;"
            lastText="&raquo;">
          </pagination>
        </div>
      </div>
    </div>

    <div class="col-xl-4" *ngIf="selectedPayment">
      <div class="payment-detail">
        <div class="payment-detail-header">
          <div>
            <span class="badge mr-2" [ngClass]="providerBadgeClass(selectedPayment.provider)">
              {{ providerLabel(selectedPayment.provider) }}
            </span>
            <strong>{{ selectedPayment.formatted_amount }}</strong>
          </div>
          <button class="btn btn-sm btn-link" (click)="selectedPayment = null" title="Close">
            <i class="fa fa-times"></i>
          </button>
        </div>

        <dl class="row mb-0">
          <dt class="col-sm-5">Transaction</dt>
          <dd class="col-sm-7 text-monospace small">{{ selectedPayment.transaction_id || '-' }}</dd>

          <dt class="col-sm-5">Provider Status</dt>
          <dd class="col-sm-7">{{ statusLabel(selectedPayment.provider_status) }}</dd>

          <dt class="col-sm-5">Reconciliation</dt>
          <dd class="col-sm-7">{{ statusLabel(selectedPayment.workflow_status) }}</dd>

          <dt class="col-sm-5">Payer</dt>
          <dd class="col-sm-7">{{ selectedPayment.payer_name || '-' }}</dd>

          <dt class="col-sm-5">Email</dt>
          <dd class="col-sm-7">{{ selectedPayment.payer_email || '-' }}</dd>

          <dt class="col-sm-5">Payment Method</dt>
          <dd class="col-sm-7">{{ selectedPayment.payment_method_display || '-' }}</dd>

          <dt class="col-sm-5">Matter</dt>
          <dd class="col-sm-7">
            <button class="btn btn-sm btn-link p-0" (click)="viewMatter(selectedPayment)" *ngIf="selectedPayment.matter_id">
              {{ selectedPayment.matter_number || selectedPayment.matter_name || selectedPayment.matter_id }}
            </button>
            <span *ngIf="!selectedPayment.matter_id">-</span>
          </dd>

          <dt class="col-sm-5">Contact</dt>
          <dd class="col-sm-7">
            <button class="btn btn-sm btn-link p-0" (click)="viewContact(selectedPayment)" *ngIf="selectedPayment.contact_id">
              {{ selectedPayment.contact_name || selectedPayment.contact_id }}
            </button>
            <span *ngIf="!selectedPayment.contact_id">-</span>
          </dd>

          <dt class="col-sm-5">Invoice</dt>
          <dd class="col-sm-7">
            <button class="btn btn-sm btn-link p-0" (click)="viewInvoice(selectedPayment)" *ngIf="selectedPayment.invoice_id">
              {{ selectedPayment.invoice_reference || selectedPayment.payload_invoice_id || selectedPayment.invoice_id }}
            </button>
            <span *ngIf="!selectedPayment.invoice_id">{{ selectedPayment.invoice_reference || '-' }}</span>
          </dd>

          <dt class="col-sm-5" *ngIf="selectedPayment.payload_deposit_ids && selectedPayment.payload_deposit_ids.length">Payload Deposits</dt>
          <dd class="col-sm-7 text-monospace small" *ngIf="selectedPayment.payload_deposit_ids && selectedPayment.payload_deposit_ids.length">
            <div *ngFor="let depositId of selectedPayment.payload_deposit_ids">{{ depositId }}</div>
          </dd>
        </dl>

	        <div class="detail-actions mt-3">
	          <button class="btn btn-sm btn-outline-primary mr-2" (click)="viewReceipt(selectedPayment)" *ngIf="selectedPayment.receipt_id">
	            <i class="fa fa-file-text-o"></i> Receipt
	          </button>
	          <button class="btn btn-sm btn-outline-secondary" (click)="viewEntryGroup(selectedPayment)" *ngIf="selectedPayment.entry_group_id">
	            <i class="fa fa-sitemap"></i> Entry Group
	          </button>
	          <button class="btn btn-sm btn-outline-danger ml-2" (click)="openRefundModal(selectedPayment)" *ngIf="canRefund(selectedPayment)">
	            <i class="fa fa-undo"></i> Refund
	          </button>
	        </div>
	      </div>
	    </div>
	  </div>
	</div>

	<div class="modal fade" [class.show]="showRefundModal" [style.display]="showRefundModal ? 'block' : 'none'" tabindex="-1">
	  <div class="modal-dialog">
	    <div class="modal-content">
	      <div class="modal-header bg-danger text-white">
	        <h5 class="modal-title">
	          <i class="fa fa-undo"></i> Process Refund
	        </h5>
	        <button type="button" class="close text-white" (click)="closeRefundModal()">
	          <span>&times;</span>
	        </button>
	      </div>
	      <div class="modal-body" *ngIf="refundPayment">
	        <div class="alert alert-warning">
	          <i class="fa fa-exclamation-triangle"></i>
	          <span *ngIf="refundPayment.provider === 'lawpay'">This submits a refund to LawPay. V7 records the bookkeeping only after LawPay sends the refund callback.</span>
	          <span *ngIf="refundPayment.provider === 'payload'">This submits a refund to Payload for this payment transaction.</span>
	        </div>

	        <div class="form-group">
	          <label><strong>Payment Details</strong></label>
	          <p class="mb-1">Payer: {{ refundPayment.payer_name || 'Unknown' }}</p>
	          <p class="mb-1">Original Amount: {{ refundPayment.formatted_amount }}</p>
	          <p class="mb-0">Transaction: {{ refundPayment.transaction_id }}</p>
	        </div>

	        <hr>

	        <div class="form-group">
	          <label for="onlineRefundAmount">Refund Amount</label>
	          <div class="input-group">
	            <div class="input-group-prepend">
	              <span class="input-group-text">$</span>
	            </div>
	            <input type="number"
	                   class="form-control"
	                   id="onlineRefundAmount"
	                   [(ngModel)]="refundAmount"
	                   (ngModelChange)="loadRefundPreview()"
	                   [max]="refundPayment.amount"
	                   min="0.01"
	                   step="0.01">
	          </div>
	          <small class="text-muted">Maximum: {{ refundPayment.formatted_amount }}</small>
	        </div>

	        <div class="form-group" *ngIf="loadingPreview">
	          <small class="text-muted"><i class="fa fa-spinner fa-spin"></i> Calculating allocation...</small>
	        </div>

	        <div class="form-group" *ngIf="refundPayment.provider === 'lawpay' && refundPreview && !loadingPreview">
	          <label><strong>Allocation Preview</strong></label>
	          <table class="table table-sm table-bordered mb-1">
	            <thead class="thead-light">
	              <tr>
	                <th>Original Bill</th>
	                <th class="text-right">Paid</th>
	                <th class="text-right">Already Refunded</th>
	                <th class="text-right">Will Refund</th>
	              </tr>
	            </thead>
	            <tbody>
	              <tr *ngFor="let a of refundPreview.allocations" [class.text-muted]="a.will_refund == 0">
	                <td>{{ a.paid_bill_summary }}</td>
	                <td class="text-right">{{ a.original_amount | currency }}</td>
	                <td class="text-right">{{ a.already_refunded | currency }}</td>
	                <td class="text-right"><strong>{{ a.will_refund | currency }}</strong></td>
	              </tr>
	              <tr *ngIf="refundPreview.allocations.length === 0">
	                <td colspan="4" class="text-muted text-center">No payment bills found; refund will be unallocated.</td>
	              </tr>
	            </tbody>
	          </table>
	          <small class="text-warning" *ngIf="refundPreview.note">{{ refundPreview.note }}</small>
	        </div>

	        <div class="form-group">
	          <label for="onlineRefundReason">Reason for Refund</label>
	          <textarea class="form-control"
	                    id="onlineRefundReason"
	                    [(ngModel)]="refundReason"
	                    rows="3"
	                    placeholder="Enter reason for refund..."></textarea>
	        </div>
	      </div>
	      <div class="modal-footer">
	        <button type="button" class="btn btn-secondary" (click)="closeRefundModal()" [disabled]="refunding">
	          Cancel
	        </button>
	        <button type="button" class="btn btn-danger" (click)="confirmRefund()" [disabled]="refunding">
	          <i class="fa fa-undo" *ngIf="!refunding"></i>
	          <i class="fa fa-spinner fa-spin" *ngIf="refunding"></i>
	          Process Refund
	        </button>
	      </div>
	    </div>
	  </div>
	</div>
	<div class="modal-backdrop fade show" *ngIf="showRefundModal"></div>
